import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { triggerEvent } from '@/services/tracking'

export default function LanguageToggle() {
  const { i18n } = useTranslation()

  // Set direction when language changes
  useEffect(() => {
    document.dir = i18n.language === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  // Initialize on mount only
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage')
    if (savedLanguage && savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage)
    }
  }, [i18n])

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ar' ? 'en' : 'ar'
    i18n.changeLanguage(newLang)

    // Update document direction and language
    document.dir = newLang === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.lang = newLang

    // Store preference
    localStorage.setItem('preferredLanguage', newLang)

    // Track language change
    triggerEvent('language_changed', {
      from: i18n.language,
      to: newLang,
    })
  }

  return (
    <button
      onClick={toggleLanguage}
      className="px-3 py-1.5 text-sm font-semibold text-olive-700 bg-olive-50 rounded-lg hover:bg-olive-100 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-olive-400 focus:ring-offset-1"
      aria-label={i18n.language === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}
    >
      {i18n.language === 'ar' ? 'EN' : 'عربي'}
    </button>
  )
}
